import type { MeContext } from '@vizit/api';
import type { AccessRouteParams } from '../types';
import { findPortfolioById } from './find-portfolio-by-id';
import { findWorkspaceBySlug } from './find-workspace-by-slug';
import { getAccessibleWorkspaces } from './get-accessible';
import { resolveLanding } from './resolve-landing';

// Resolution order: /w/:slug param → landing workspace → default portfolio's default workspace.
export function resolveActiveWorkspace(context: MeContext, routeParams: AccessRouteParams = {}): string | null {
  if (routeParams.workspaceSlug) {
    const bySlug = findWorkspaceBySlug(context, routeParams.workspaceSlug);
    if (bySlug) {
      return bySlug.id;
    }
  }

  const landing = resolveLanding(context);
  if (landing.type === 'workspace') {
    return landing.workspaceId;
  }

  const portfolio = findPortfolioById(context, context.organization.defaultPortfolioId);
  return portfolio?.defaultWorkspaceId ?? null;
}

export function resolveActiveWorkspaceSlug(context: MeContext, routeParams: AccessRouteParams = {}): string | null {
  const workspaceId = resolveActiveWorkspace(context, routeParams);

  return getAccessibleWorkspaces(context).find((workspace) => workspace.id === workspaceId)?.slug ?? null;
}
